import folders from "./modules/folders"
import mails from "./modules/mail"

export default {
    modules: {
        folders,
        mails
    }
}
